<template>
    <div id="multiplayer-component">
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    export default {
        name: "MultiplayerComponent",
        data() {
            return {
                count_connection: 0,
                ip              : null,
                ws              : null,
                ws_count        : 0
            }
        },
        computed: {
            ...mapGetters(['token', 'logged', 'id', 'name', 'email', 'points', 'player'])
        },
        methods: {
            ...mapActions(['update', 'update_profile', 'increment', 'update_player']),


            /*----- websocket -----*/
            messageHandler(data) {
                //console.log(data);
                switch(String(data.type)) {
                    case "connected":
                    break;
                    case "disconnected":
                        console.log("disconnected -> ", data.player, this.player);
                        if (data.player !== this.player) {
                            this.$parent.$children[3].removePlayer(data.player);
                        }
                    break;
                    case "started":
                        console.log("started -> ", data.player);
                        if (data.id_user === this.id) {
                            this.update_player(data.player);
                            this.$parent.$children[3].updateMyPlayer(data.player, data.players);
                        } else {
                            this.$parent.$children[3].addPlayer(data.players);
                        }
                    break;
                    case "refresh":
                        this.$parent.$children[3].refreshPlayer(data);
                    break;
                }
            },
            connect() {
                let root_ = this;
                //this.ws = new WebSocket('wss://boticario.xbt.com.br/ws/');
                this.ws = new WebSocket('ws://local.agrinhos.com.br:8043/websocket/');
                this.ws.onopen = function() {
                    console.log('connected');
                    root_.ws_count = 0;
                    root_.ws.send(JSON.stringify({ type:'started', id_user: root_.id }));
                };
                this.ws.onerror = function(e) {
                    e;
                    if (root_.ws_count < 5)
                    {
                        root_.ws_count++;
                        root_.connect();
                    }
                };
                this.ws.onmessage = function(e) {
                    root_.messageHandler(JSON.parse(e.data));
                };
            },
            /*----- \websocket\ -----*/



        },
        mounted() {
            
        }
    }
</script>

<style scoped>
    #multiplayer-component {
        position: absolute;
    }
</style>
